import React, { Component, useState, useEffect, useRef } from 'react';
import { Image, Button, Icon, Header,  Message, Container, Segment } from 'semantic-ui-react'



function Home() {


    return (
        
        <>
        <Segment size='huge' textAlign='center' color='blue' inverted>Northwind Trading Demo Application</Segment>
        <Segment textAlign='center'>
            <Image src="/lighthouse.png" circular centered/>
        </Segment>
        <Segment>
        <Container text>
            <Header as='h2'>Welcome</Header>
            <p>
                Welcome to the Northwind Demo running serverless on AWS.
                This is a work in progress learning project. The source will
                be published so that there can be contributions and hints
                by the community.
                <p/><p/>
                On the Info page, there will be details about the used technologies
                and architecture.
                <p/><p/>
                <b>Please be aware of one known issue:</b> If in idle state, the underlying
                Aurora database may need about 30 secs to wake up. That can cause a delay on
                database related actions or also a backend error for the very first request. 
                In this case, please retry.
            </p>
        </Container>            
        </Segment>

        </>
    )
}

export default Home